import { ATS_APP_PUBLIC_NAME } from '@alliance/shared/constants'
import { OnboardingCategoriesEnum } from '../../domain/models/onboarding-categories.enum'

const categoriesTitles: Record<OnboardingCategoriesEnum, string> = {
  [OnboardingCategoriesEnum.candidatesInProject]: 'Як отримати кандидатів в проєкти',
  [OnboardingCategoriesEnum.whereToStart]: 'З чого почати роботу ',
  [OnboardingCategoriesEnum.actionsWithCandidates]: 'Дії з кандидатом',
  [OnboardingCategoriesEnum.funnel]: 'Налаштування воронки найму',
  [OnboardingCategoriesEnum.statisticsAndAnalytics]: 'Статистика та аналітика',
  [OnboardingCategoriesEnum.userRights]: 'Доступ колег і замовників'
}

const categoriesDescriptions: Record<OnboardingCategoriesEnum, string> = {
  [OnboardingCategoriesEnum.candidatesInProject]: 'Експорт відгуків з джерел, способи додавання кандидатів вручну та з бази',
  [OnboardingCategoriesEnum.whereToStart]: `Три простих кроки для початку роботи в вашому кабінеті ${ATS_APP_PUBLIC_NAME}`,
  [OnboardingCategoriesEnum.actionsWithCandidates]: `Історія подій, комунікація, причини відмови,  відправка резюме, теги, зустрічі з кандидатами`,
  [OnboardingCategoriesEnum.funnel]: `Робота з канбаном, створення власних етапів, шаблони для різних типів найму`,
  [OnboardingCategoriesEnum.statisticsAndAnalytics]: `Воронка найму, дані про ефективність джерел, активності рекрутерів та причин відмови`,
  [OnboardingCategoriesEnum.userRights]: `Розподіл прав доступу до проєкту для команди рекрутингу та замовників`
}

export default {
  title: `Корисні можливості ${ATS_APP_PUBLIC_NAME}`,
  categories: { titles: { ...categoriesTitles }, descriptions: { ...categoriesDescriptions } },
  tooltip: 'Довідка'
}
